import { useState, useEffect, useCallback } from "react";
import Button from "./Button";
import { ReactComponent as SearchIcon } from "../../assets/icons/search.svg";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import axios from "axios";

const Searching = (props) => {
  const [isSearching, setIsSearching] = useState(false);
  const [prevSearchValue, setPrevSearchValue] = useState(""); // Track previous search value
  const {
    data,
    dataCount,
    setData,
    setCount,
    setPage,
    searchValue,
    setSearch,
    type,
    serverSearching,
    placeholder,
    button,
    newClass,
    btnShow,
    actionShow,
    paginationSubmitButton,
    setActionPagination,
    actionPagination,
    customSelectDataShow,
    customSelectData,
    label,
    actionPaginationDataCustom,
    apiEndpoint,
    limit,
    page
  } = props;

  // Debounce function to delay API calls
  // const debounce = (func, delay) => {
  //   let timeoutId;
  //   return function (...args) {
  //     if (timeoutId) {
  //       clearTimeout(timeoutId);
  //     }
  //     timeoutId = setTimeout(() => {
  //       func.apply(this, args);
  //     }, delay);
  //   };
  // };

  // Handle search input change with debounce
  const handleSearchInputChange = (e) => {
    const inputValue = e.target.value;
    setSearch(inputValue);

    // If input is empty, reset data but don't change page here
    if (!inputValue) {
      setData(data);
      setCount(dataCount); // Reset count to original data count
      return
    }
  };

  // Make API call for server-side searching
  const debouncedServerSearch = useCallback(
    async (searchTerm) => {
      if (type !== "client" && searchTerm) {
        setIsSearching(true);
        try {
          // You can customize the endpoint and parameters based on your API structure
          const response = await axios.get(apiEndpoint, {
            params: {
              searchText: searchTerm,
              page: page || 1, 
              limit: limit || 10, // Default limit if not provided
              // You can add other parameters here like page, limit, etc.
            },
          });

          // Handle the search results
          if (response.data) {
            setData(response.data.data.allData);
            setCount(response.data.data.totalCount);
          }
        } catch (error) {
          // console.error("Search API error:", error);
        } finally {
          setIsSearching(false);
        }
      }
    },
    [type, apiEndpoint, setData, setCount, page, limit]  // Remove setSearch from dependencies
  );

  // Use effect to handle debounced search
  useEffect(() => {
    // Only reset to page 1 when the search value changes from non-empty to another non-empty value
    // or from empty to non-empty (initiating a new search)
    if (searchValue !== prevSearchValue) {
      if (searchValue === "" && prevSearchValue !== "") {
        // Search was cleared - reset data and count but don't change page
        setData(data);
        setCount(dataCount);
        return
      } else if (searchValue !== "" && prevSearchValue === "") {
        // First time searching - reset to page 1
        if (page !== 1) setPage(1);
      } else if (searchValue !== "" && prevSearchValue !== "" && searchValue !== prevSearchValue) {
        // Search term changed - reset to page 1
        if (page !== 1) setPage(1);
      }
      
      // Update previous search value
      setPrevSearchValue(searchValue);
    }

    // Only perform search if there's a search value
    if (searchValue && searchValue.trim() !== "") {
      if (type !== "client") {
        const handler = setTimeout(() => {
          debouncedServerSearch(searchValue);
        }, 500); // 500ms delay

        return () => {
          clearTimeout(handler);
        };
      }
    }
  }, [searchValue, type, debouncedServerSearch, data, dataCount, page, setPage]);

  // const handleSearch = async (event) => {
  //   event.preventDefault();

  //   let searchValue = search ? search : event?.target?.value?.toLowerCase();
  //   const getLowerCaseSearch = searchValue?.toLowerCase();

  //   if (getLowerCaseSearch !== undefined) {
  //     if (type === "client") {
  //       if (getLowerCaseSearch) {
  //         // Keeping the existing client-side filtering logic
  //         const filteredData = data.filter((item) => {
  //           return Object.keys(item).some((key) => {
  //             if (key === "_id" || key === "updatedAt" || key === "createdAt") {
  //               return false;
  //             }
  //             const itemValue = item[key];
  //             if (typeof itemValue === "string") {
  //               return itemValue.toLowerCase().indexOf(getLowerCaseSearch) > -1;
  //             } else if (typeof itemValue === "number") {
  //               return itemValue.toString().indexOf(getLowerCaseSearch) > -1;
  //             } else if (typeof itemValue === "object" && itemValue !== null) {
  //               // Check for nested object (agencyId) and handle nested properties
  //               return Object.values(itemValue).some((nestedValue) => {
  //                 if (typeof nestedValue === "string") {
  //                   return (
  //                     nestedValue.toLowerCase().indexOf(getLowerCaseSearch) > -1
  //                   );
  //                 }
  //                 return false;
  //               });
  //             }
  //             return false;
  //           });
  //         });
  //         setData(filteredData); // Update the filteredData state
  //       } else {
  //         setData(data); // Reset the filteredData state to the original data
  //       }
  //     } else {
  //       // For server-side searching, use the debounced function directly
  //       debouncedServerSearch(getLowerCaseSearch);
  //     }
  //   }
  // };

  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSearchInputChange(e);
    }
  };

  const paginationActionData = actionPaginationDataCustom
    ? actionPaginationDataCustom
    : ["Block", "Unblock", "Delete"];


  return (
    <>
      <div className="row search-action" style={{ paddingRight: "3px" }}>
        <div className="col-12 col-lg-6 col-md-6 col-sm-12 ">
          <div className=" searching-box " style={{ float: "right" }}>
            <div
              className={`prime-input search-input-box  m-0 ${newClass}`}
              style={{ borderRadius: "62px" }}
            >
              <label
                className="mb-3 mt-3"
                style={{ fontSize: "15px", fontWeight: "400", color: "unset" }}
              >
                {label}
              </label>

              <input
                type="search"
                autoComplete="false"
                placeholder={placeholder}
                aria-describedby="button-addon4"
                className="form-input searchBarBorderr "
                style={{
                  borderRadius: "62px",
                  borderBottomRightRadius: "0px",
                  borderTopRightRadius: "0px",
                  height: "56px",
                  paddingLeft: "20px",
                }}
                onChange={handleSearchInputChange}
                onKeyPress={handleKeyPress}
                value={searchValue}
              />

              {button && (
                <Button
                  type="button"
                  btnIcon={<SearchIcon />}
                  newClass={`themeBtn text-center fs-6  searchBtn text-white ${
                    isSearching ? "disabled" : ""
                  }`}
                  onClick={(e) => handleSearchInputChange(e)}
                  disabled={isSearching}
                />
              )}
            </div>
          </div>
        </div>
        <div className="col-12 col-lg-6 col-md-6 col-sm-12  pagination-select p-0">
          <div className="d-flex align-items-center justify-content-end w-100 pagination-box">
            {actionShow === false ? (
              ""
            ) : (
              <>
                <div className="pagination-submit me-3">
                  <FormControl>
                    <InputLabel
                      id="demo-simple-select-label"
                      style={{
                        fontWeight: "500",
                        fontSize: "17px",
                        marginBottom: "10px",
                      }}
                    >
                      Action
                    </InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                      id="demo-simple-select"
                      value={actionPagination}
                      label="Action"
                      onChange={(e) => setActionPagination(e.target.value)}
                    >
                      {customSelectDataShow
                        ? customSelectData?.map((item) => {
                            return (
                              <MenuItem value={item?.toLowerCase()} key={item}>
                                {item}
                              </MenuItem>
                            );
                          })
                        : paginationActionData?.map((item) => {
                            return (
                              <MenuItem value={item?.toLowerCase()} key={item}>
                                {item}
                              </MenuItem>
                            );
                          })}
                    </Select>
                  </FormControl>
                </div>
                <Button
                  newClass={"submit-btn-dialogue py-2"}
                  onClick={paginationSubmitButton}
                  btnName={"Submit"}
                  style={{ marginRight: "10px" }}
                />
              </>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default Searching;
